import { useParams, useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowLeft, Phone, Mail } from "lucide-react";
import { Logo } from "../components/Logo";
import { GATEWAYS, CONTACT } from "../lib/data";

export default function ComingSoon() {
  const { gateway } = useParams();
  const navigate = useNavigate();
  const data = GATEWAYS.find((g) => g.key === gateway);

  const title = data ? data.title : "Page";
  const body = data
    ? data.body
    : "This section isn't available yet.";
  const color = data ? data.color : "#e62429";

  return (
    <div
      data-testid={`coming-soon-${gateway || "unknown"}`}
      className="relative isolate min-h-[100svh] bg-[#0a0a0a] flex flex-col"
    >
      {data && (
        <div className="absolute inset-0 z-0">
          <img
            src={data.image}
            alt={title}
            className="h-full w-full object-cover grayscale opacity-30"
          />
          <div className="absolute inset-0 bg-[#0a0a0a]/80" />
          <div
            className="absolute inset-0 opacity-20 mix-blend-multiply"
            style={{ backgroundColor: color }}
          />
        </div>
      )}

      <header className="relative z-10 mx-auto max-w-[1500px] w-full px-5 sm:px-8 py-6">
        <Logo />
      </header>

      <div className="relative z-10 mx-auto max-w-[1500px] w-full px-5 sm:px-8 flex-1 flex flex-col justify-center py-16">
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1] }}
        >
          <p
            className="text-xs font-bold uppercase tracking-[0.35em] mb-6"
            style={{ color }}
          >
            Explore · {title}
          </p>
          <h1 className="font-display uppercase text-white text-6xl sm:text-8xl lg:text-[10vw] leading-[0.85]">
            {title}
          </h1>
          <p className="mt-6 max-w-xl text-lg text-neutral-300 leading-relaxed">
            {body}
          </p>

          <div className="mt-10 inline-flex items-center gap-3 border border-white/20 px-6 py-4">
            <span
              className="h-2.5 w-2.5 rounded-full animate-pulse"
              style={{ backgroundColor: color }}
            />
            <span className="font-display text-2xl text-white">COMING SOON</span>
          </div>

          <p className="mt-10 text-neutral-400 max-w-lg">
            This gateway is on the way. In the meantime, a conversation is
            usually a better place to start.
          </p>

          <div className="mt-8 flex flex-wrap items-center gap-4">
            <a
              href={`tel:${CONTACT.phoneHref}`}
              data-testid="cs-call-link"
              className="group inline-flex items-center gap-3 bg-[#e62429] px-6 py-4 text-sm font-bold uppercase tracking-[0.15em] text-white hover:bg-white hover:text-black transition-colors duration-300"
            >
              <Phone className="h-5 w-5" /> {CONTACT.phone}
            </a>
            <a
              href={`mailto:${CONTACT.email}`}
              data-testid="cs-email-link"
              className="group inline-flex items-center gap-3 border border-white/25 px-6 py-4 text-sm font-bold uppercase tracking-[0.15em] text-white hover:bg-white hover:text-black transition-colors duration-300"
            >
              <Mail className="h-5 w-5" /> Email us
            </a>
          </div>

          <button
            type="button"
            data-testid="cs-back-link"
            onClick={() => navigate("/")}
            className="mt-12 inline-flex items-center gap-2 text-xs font-bold uppercase tracking-[0.2em] text-neutral-400 hover:text-white transition-colors"
          >
            <ArrowLeft className="h-4 w-4" /> Back to home
          </button>
        </motion.div>
      </div>
    </div>
  );
}
